import { Host, h } from "@stencil/core";
export class ChSuggestList {
    constructor() {
        this.label = undefined;
    }
    // 2.REFERENCE TO ELEMENTS //
    // 3.STATE() VARIABLES //
    // 4.PUBLIC PROPERTY API / WATCH'S //
    // 5.EVENTS (EMIT) //
    // 6.COMPONENT LIFECYCLE EVENTS //
    // 7.LISTENERS //
    // 8.PUBLIC METHODS API //
    // 9.LOCAL METHODS //
    // 10.RENDER() FUNCTION //
    render() {
        return (h(Host, null, this.label && (h("h2", { id: "heading", part: "title", class: "title" }, this.label)), h("ul", { "aria-labelledby": this.label ? "heading" : undefined, part: "list", class: "list" }, h("slot", null))));
    }
    static get is() { return "ch-suggest-list"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-suggest-list.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-suggest-list.css"]
        };
    }
    static get properties() {
        return {
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The label"
                },
                "attribute": "label",
                "reflect": false
            }
        };
    }
}
//# sourceMappingURL=ch-suggest-list.js.map
